/**
 * Meta CAPI `_fbc` (Facebook Click ID) cookie — set once at app bootstrap.
 *
 * Imported for its side effect as one of the first modules in `main.tsx`, so the cookie is
 * written before the app can send its first CAPI event.
 */
import { syncFbcWithUrl } from '@/helpers/fbc'

syncFbcWithUrl()
